export const THEMES = {
  classic: {
    id: "classic",
    name: "Classic",
    tagline: "Restrained terminal aesthetic.",
    icon: "⌨️",
    preview: "Clean dark mono",
    colors: {
      "--bg-primary": "#0e0f13",
      "--bg-secondary": "#181a20",
      "--bg-overlay": "rgba(14, 15, 19, 0.04)",
      "--text-primary": "#e8e8ec",
      "--text-secondary": "#9a9aa3",
      "--text-accent": "#a5b9d4",
      "--text-accent2": "#6dd3ff",
      "--border-primary": "#2a2c33",
      "--border-glow": "rgba(160, 175, 200, 0.18)",
      "--link-color": "#6dd3ff",
      "--link-hover": "#a8e5ff",
      "--btn-bg": "transparent",
      "--btn-hover-bg": "#2a2c33",
      "--btn-hover-text": "#e8e8ec",
      "--scrollbar-thumb": "#2a2c33",
      "--scrollbar-track": "#0e0f13",
    },
    font: "'Courier New', monospace",
    effects: {
      scanlines: false,
      flicker: false,
      matrixRain: false,
      bgAnimation: "none",
      crt: false,
      neonGlow: false,
      blink: false,
      marquee: false,
      rainbowHeaders: false,
      cursorStyle: null,
      glitter: false,
    },
  },

  terminal: {
    id: "terminal",
    name: "The Matrix",
    tagline: "Wake up, Neo...",
    icon: "💊",
    preview: "Green phosphor CRT terminal",
    colors: {
      "--bg-primary": "#001100",
      "--bg-secondary": "#002200",
      "--bg-overlay": "rgba(0, 17, 0, 0.05)",
      "--text-primary": "#00ff00",
      "--text-secondary": "#00cc00",
      "--text-accent": "#ffff00",
      "--text-accent2": "#00ffff",
      "--border-primary": "#00ff00",
      "--border-glow": "rgba(0, 255, 0, 0.3)",
      "--link-color": "#00ffff",
      "--link-hover": "#ffff00",
      "--btn-bg": "transparent",
      "--btn-hover-bg": "#00ff00",
      "--btn-hover-text": "#001100",
      "--scrollbar-thumb": "#004400",
      "--scrollbar-track": "#001100",
    },
    font: "'Courier New', monospace",
    effects: {
      scanlines: true,
      flicker: true,
      matrixRain: true,
      bgAnimation: "none",
      crt: true,
      neonGlow: false,
      blink: false,
      marquee: false,
      rainbowHeaders: false,
      cursorStyle: null,
      glitter: false,
    },
  },

  bladerunner: {
    id: "bladerunner",
    name: "Blade Runner",
    tagline: "All those moments will be lost in time, like tears in rain...",
    icon: "🌧️",
    preview: "Neon noir cyberpunk",
    colors: {
      "--bg-primary": "#0a0a14",
      "--bg-secondary": "#141428",
      "--bg-overlay": "rgba(10, 10, 20, 0.06)",
      "--text-primary": "#e0d0ff",
      "--text-secondary": "#a090cc",
      "--text-accent": "#ff6ec7",
      "--text-accent2": "#00e5ff",
      "--border-primary": "#ff6ec7",
      "--border-glow": "rgba(255, 110, 199, 0.3)",
      "--link-color": "#00e5ff",
      "--link-hover": "#ff6ec7",
      "--btn-bg": "transparent",
      "--btn-hover-bg": "#ff6ec7",
      "--btn-hover-text": "#0a0a14",
      "--scrollbar-thumb": "#3a2060",
      "--scrollbar-track": "#0a0a14",
    },
    font: "'Courier New', monospace",
    effects: {
      scanlines: true,
      flicker: false,
      matrixRain: false,
      bgAnimation: "rain",
      crt: false,
      neonGlow: true,
      blink: false,
      marquee: false,
      rainbowHeaders: false,
      cursorStyle: null,
      glitter: false,
    },
  },

  win95: {
    id: "win95",
    name: "Windows 95",
    tagline: "Where do you want to go today?",
    icon: "🖥️",
    preview: "Classic desktop nostalgia",
    colors: {
      "--bg-primary": "#008080",
      "--bg-secondary": "#c0c0c0",
      "--bg-overlay": "rgba(0, 128, 128, 0.03)",
      "--text-primary": "#000000",
      "--text-secondary": "#404040",
      "--text-accent": "#000080",
      "--text-accent2": "#800000",
      "--border-primary": "#dfdfdf",
      "--border-glow": "rgba(255, 255, 255, 0.2)",
      "--link-color": "#0000ff",
      "--link-hover": "#800080",
      "--btn-bg": "#c0c0c0",
      "--btn-hover-bg": "#000080",
      "--btn-hover-text": "#ffffff",
      "--scrollbar-thumb": "#c0c0c0",
      "--scrollbar-track": "#808080",
    },
    font: "'Courier New', 'MS Sans Serif', monospace",
    effects: {
      scanlines: false,
      flicker: false,
      matrixRain: false,
      bgAnimation: "none",
      crt: false,
      neonGlow: false,
      blink: false,
      marquee: false,
      rainbowHeaders: false,
      cursorStyle: null,
      glitter: false,
    },
  },

  tron: {
    id: "tron",
    name: "Tron Legacy",
    tagline: "The Grid. A digital frontier.",
    icon: "⚡",
    preview: "Electric blue digital grid",
    colors: {
      "--bg-primary": "#050510",
      "--bg-secondary": "#0a0a20",
      "--bg-overlay": "rgba(5, 5, 16, 0.05)",
      "--text-primary": "#6fefff",
      "--text-secondary": "#4ac8e0",
      "--text-accent": "#ffffff",
      "--text-accent2": "#ff8800",
      "--border-primary": "#6fefff",
      "--border-glow": "rgba(111, 239, 255, 0.4)",
      "--link-color": "#ff8800",
      "--link-hover": "#6fefff",
      "--btn-bg": "transparent",
      "--btn-hover-bg": "#6fefff",
      "--btn-hover-text": "#050510",
      "--scrollbar-thumb": "#1a3a50",
      "--scrollbar-track": "#050510",
    },
    font: "'Courier New', monospace",
    effects: {
      scanlines: false,
      flicker: false,
      matrixRain: false,
      bgAnimation: "grid",
      crt: false,
      neonGlow: true,
      blink: false,
      marquee: false,
      rainbowHeaders: false,
      cursorStyle: null,
      glitter: false,
    },
  },

  myspace: {
    id: "myspace",
    name: "MySpace",
    tagline: "Thanks for the add! ✌️",
    icon: "🎵",
    preview: "2005 internet chaos energy",
    colors: {
      "--bg-primary": "#003366",
      "--bg-secondary": "#1a1a2e",
      "--bg-overlay": "rgba(0, 51, 102, 0.04)",
      "--text-primary": "#ffffff",
      "--text-secondary": "#ccccff",
      "--text-accent": "#ff00ff",
      "--text-accent2": "#00ffff",
      "--border-primary": "#ff00ff",
      "--border-glow": "rgba(255, 0, 255, 0.4)",
      "--link-color": "#00ffff",
      "--link-hover": "#ff00ff",
      "--btn-bg": "transparent",
      "--btn-hover-bg": "#ff00ff",
      "--btn-hover-text": "#000000",
      "--scrollbar-thumb": "#ff00ff",
      "--scrollbar-track": "#003366",
    },
    font: "'Comic Sans MS', 'Courier New', cursive",
    effects: {
      scanlines: false,
      flicker: false,
      matrixRain: false,
      bgAnimation: "sparkles",
      crt: false,
      neonGlow: false,
      blink: false,
      marquee: true,
      rainbowHeaders: false,
      cursorStyle: null,
      glitter: true,
    },
  },

  geocities: {
    id: "geocities",
    name: "Geocities",
    tagline: "Welcome to my homepage!!! =)",
    icon: "🚧",
    preview: "1998 homepage chaos",
    colors: {
      "--bg-primary": "#000033",
      "--bg-secondary": "#000066",
      "--bg-overlay": "rgba(0, 0, 51, 0.04)",
      "--text-primary": "#ffff00",
      "--text-secondary": "#ffcc00",
      "--text-accent": "#ff0000",
      "--text-accent2": "#ff00ff",
      "--border-primary": "#ffff00",
      "--border-glow": "rgba(255, 255, 0, 0.4)",
      "--link-color": "#00ff00",
      "--link-hover": "#ff00ff",
      "--btn-bg": "#000080",
      "--btn-hover-bg": "#ffff00",
      "--btn-hover-text": "#000033",
      "--scrollbar-thumb": "#ffff00",
      "--scrollbar-track": "#000033",
    },
    font: "'Comic Sans MS', 'Times New Roman', cursive, serif",
    effects: {
      scanlines: false,
      flicker: false,
      matrixRain: false,
      bgAnimation: "stars",
      crt: false,
      neonGlow: false,
      blink: true,
      marquee: true,
      rainbowHeaders: true,
      cursorStyle: "crosshair",
      glitter: false,
    },
  },
};

export const THEME_IDS = Object.keys(THEMES);
export const DEFAULT_THEME = "classic";
